export const fmtMoney = (v) => {
  if (v == null || Number.isNaN(Number(v))) return "—";
  const n = Math.round(Number(v));
  return n < 0 ? `-$${Math.abs(n).toLocaleString()}` : `$${n.toLocaleString()}`;
};

export const fmtSigned = (v) => {
  if (v == null || Number.isNaN(Number(v))) return "—";
  const n = Math.round(Number(v));
  return n >= 0 ? `+$${n.toLocaleString()}` : `-$${Math.abs(n).toLocaleString()}`;
};

export const fmtPct = (v, d = 1) => (v == null || Number.isNaN(Number(v)) ? "—" : `${Number(v).toFixed(d)}%`);

export const dealProperty = (deal) => deal?.property || deal || {};
